<template>
  <el-card>
    <i class="el-icon-refresh" @click="reload()" style="position: absolute;top: 10px;right: 20px;cursor: pointer;"></i>
    <SweetTable :is-page="false" ref="table" url="/erp/settle/material/list" :query-form="dataForm"
      :before-table-binding="beforeTableBinding2" :row-style="rowStyleHandler"
      :summariesColumn="['totalAmount', 'useCount', 'limitCount', 'productSendCount']" :height="500">
      <el-table-column prop="materialInfo.name" label="品名" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="materialInfo.color" label="颜色" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="materialInfo.size" label="规格" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="materialInfo.attr1" label="幅宽" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="materialInfo.attr2" label="克重" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="purchasePlanCount" label="采购计划数" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="receiveCount" label="收货数量" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="invoiceCount" label="收货数量(已开票)" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="price" label="开票单价" header-align="center" align="center">
      </el-table-column>
      <el-table-column label="金额" header-align="center" align="center" prop="totalAmount">
      </el-table-column>
      <el-table-column prop="useCount" label="用料数量" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="limitCount" label="库存数量" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="bomCount" label="单耗" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
    </SweetTable>
  </el-card>
</template>

<script>
import BigNumber from 'bignumber.js'
import SettleReportMixin from '@/views/modules/settle/report/SettleReportMixin'

export default {
  name: 'PurchaseReport',
  mixins: [SettleReportMixin],
  props: {
    orderId: ''
  },
  data() {
    return {
      maxTableHeight: 500,
      dataForm: {
        orderId: ''
      }
    }
  },
  watch: {
    orderId: {
      handler: function (newVal) {
        if (!newVal) {
          this.$refs.table.dataList = []
          return
        }
        this.dataForm.orderId = newVal
        this.$nextTick(() => {
          this.reload()
        })
      },
      immediate: true
    }
  },
  methods: {
    rowStyleHandler({ row, rowIndex }) {
      let rowStyle={};
      if(row.isWarning===1){
        rowStyle= {
          color:'red'
        }
      }
      return rowStyle;
    },
    reload() {
      // this.$refs.table.reload()
      this.$refs.table.reload()
    },
    beforeTableBinding(dataList) {
      dataList.forEach(row => {
        if (!row.receiveCount) {
          row.receiveCount = 0
        }
        if (!row.productSendCount) {
          row.productSendCount = 0
        }
        if (!row.bomCount) {
          row.bomCount = 0
        }
        row.bomCount = new BigNumber(row.bomCount).toFixed(3)
        let useCount = new BigNumber(row.useCount)
        row.limitCount = new BigNumber(row.receiveCount || 0).minus(useCount).toFixed(2)
        row.totalAmount = new BigNumber(row.receiveCount).multipliedBy(row.price || 0).toFixed(2)
      })
    },
    beforeTableBinding2(dataList) {
      dataList.forEach(row => {
        row.limitCount = new BigNumber(row.receiveCount || 0).minus(row.useCount).toFixed(5)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
